import { render } from "./dynamicUploadImage.vue?vue&type=template&id=ed318a18"
import script from "./dynamicUploadImage.vue?vue&type=script&lang=js"
export * from "./dynamicUploadImage.vue?vue&type=script&lang=js"

import "./dynamicUploadImage.vue?vue&type=style&index=0&id=ed318a18&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__